
<mat-dialog-content class="data-protection-content">
    <button  class="close-btn data-protection-close" mat-icon-button aria-label="close dialog" mat-dialog-close>
        <mat-icon><div ><img src="/icons/close-light-grey.svg" alt="" width="20" height="20" /></div></mat-icon>
      </button>
 <div [innerHTML]="termsOfUse">
   
        </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="mat-primary  mat-accept" (click)="accept()" mat-button>{{ 'common.text_button_accept' | cxTranslate }}</button>
</mat-dialog-actions>
